<div *ngIf="isLoading()" class="loading-container">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>
<div *ngIf="isEmpty()" class="no-coupons-msg-container">
  <p>No offers available</p>
</div>
<div *ngIf="hasOffers()" class="offers-container">
  <div *ngFor="let coupon of socialOffers()" class="row social-coupon-item">
    <div class="col-md-2 col-lg-2 col-xl-2 col-xs-6 col-sm-6 col-6">
      <div class="coupon-img-container">
        <img
          class="img-responsive coupon-img center-block"
          [src]="coupon?.defaultImageUrl"
        />
      </div>
    </div>
    <div class="col-xs-6 col-sm-6 col-6 show-on-mobile text-center">
      <p class="coupon-savings">SAVE {{ coupon?.displayValue }}</p>
      <p class="coupon-expiration-text">{{ coupon?.expirationDate }}</p>
    </div>
    <div class="col-md-6 col-lg-7 col-xl-7 col-xs-12 col-sm-12 text-justify">
      <hr class="show-on-mobile hr-border" aria-hidden="true" />
      <p class="coupon-brand-name">{{ coupon?.brand }}</p>
      <p class="coupon-desc">
        {{ coupon?.shortDescription }}&nbsp;{{ coupon?.description }}
      </p>
      <div class="load-to-card-btn show-on-mobile">
        <app-coupons-button
          [coupon]="coupon"
          (doLogin)="doLoginHandler()"
        ></app-coupons-button>
      </div>
    </div>
    <div class="col-md-4 col-lg-3 col-xl-3 text-center hide-on-mobile">
      <p class="coupon-savings">SAVE {{ coupon?.displayValue }}</p>
      <div class="load-to-card-btn">
        <app-coupons-button
          [coupon]="coupon"
          (doLogin)="doLoginHandler()"
        ></app-coupons-button>
      </div>
      <p class="coupon-expiration-text">{{ coupon?.expirationDate }}</p>
    </div>
  </div>
</div>
